
export const formatRateLimitHeaderIntoMessage = (header: string) => {
  const rateLimitHeaderValues = parseRateLimitHeader(header);
  const secondsUntilRetry = rateLimitHeaderValues['t'];
  const t = new Date();
  t.setSeconds(t.getSeconds() + secondsUntilRetry);
  const formattedDate = t.toLocaleDateString('en-US', {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });

  return `Too many requests, you must wait until ${formattedDate} before you can analyze again`;
};

function parseRateLimitHeader(header: string): Record<string, number> {
  try {
    const matches = Array.from(header.matchAll(/;([a-zA-Z])=(\d+)/g));

    return matches.reduce((acc, [, key, value]) => {
      acc[key] = Number(value);
      return acc;
    }, {} );
  } catch {
    return { t: 0 };
  }
}
